import variantChangeEvent from '@/entrypoints/helpers/variantChangeEvent';
class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.init();
        this.addEventListener('change', this.onVariantChange);
    }

    init() {
        window.hasVariants = true;
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantOptions();
    }
  
    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantOptions();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
  
        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }
  
    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateVariantOptions() {
        const variantTitle = document.querySelectorAll('.js-current-variant-title');
        const variantOptionTitle = document.querySelectorAll('.js-current-variant-option-title');
        const colourOptions = document.querySelectorAll('.js-variant-colour-option');
        const colourOptionsMapped = document.querySelectorAll('.js-mapped-variant-colour-option');
        const stickyAtcImages = document.querySelectorAll('.js-product-atc-image');
        const descriptionVariants = document.querySelectorAll('.js-product-description-variants');
        
        if (variantTitle && variantTitle.length > 0) {
            variantTitle.forEach(title => {
                title.innerHTML = this.currentVariant.title;
            })
        }

        if (variantOptionTitle && variantOptionTitle.length > 0) {
            variantOptionTitle.forEach((title, index) => {
                if (index === 2) {
                    title.innerHTML = this.currentVariant.option3;
                } else if (index === 1) {
                    title.innerHTML = this.currentVariant.option2;
                } else {
                    title.innerHTML = this.currentVariant.option1;
                }
            })
        }

        if (colourOptions) {
            colourOptions.forEach(option => {
                const icon = option.querySelector('.js-variant-colour-option-icon');
                if (this.currentVariant.option1 === option.dataset.colour) {
                    option.classList.add('border-black');
                    option.classList.remove('border-transparent');
                    icon?.classList.remove('hidden')
                } else {
                    option.classList.remove('border-black');
                    option.classList.add('border-transparent');
                    icon?.classList.add('hidden')
                }
            })
        }

        if (colourOptionsMapped) {
            colourOptionsMapped.forEach(option => {
                const icon = option.querySelector('.js-variant-colour-option-icon');
                if (this.currentVariant.option1 === option.dataset.colour) {
                    option.classList.add('border-black');
                    option.classList.remove('border-transparent');
                    icon?.classList.remove('hidden')
                } else {
                    option.classList.remove('border-black');
                    option.classList.add('border-transparent');
                    icon?.classList.add('hidden')
                }
            })
        }

        if (stickyAtcImages) {
            stickyAtcImages.forEach(image => {
                if (this.currentVariant.id === parseFloat(image.dataset.variantId)) {
                    image.classList.remove('hidden');
                } else {
                    image.classList.add('hidden');
                }
            })
        }

        if (descriptionVariants && this.currentVariant.description) {
            descriptionVariants.forEach(descriptionVariant => {
                descriptionVariant.innerHTML = this.currentVariant.description;
            });
        }
        
        variantChangeEvent.emitEvent(this.currentVariant);
    }
    
    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
  
        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
    }
  
    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-template--${this.dataset.section}__main-sticky-atc-cta`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
  
    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;
  
        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }
  
    removeErrorMessage() {
        const section = this.closest('.section');
        if (!section) return;
  
        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }
  
    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.querySelectorAll(`.js-price-${this.dataset.section}`);
                const destinationMapped = document.getElementById(`price-mapped-${this.dataset.section}`);
                const source = html.querySelectorAll(`.js-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const sourceMapped = html.getElementById(`price-mapped-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

                if (source && destination) destination.forEach((destination, index) => {
                    destination.innerHTML = source[index].innerHTML;
                });
                
                if (sourceMapped && destinationMapped) destinationMapped.innerHTML = sourceMapped.innerHTML;
  
                const price = document.getElementById(`price-${this.dataset.section}`);
                const priceMapped = document.getElementById(`price-mapped-${this.dataset.section}`);
  
                if (price) price.classList.remove('visibility-hidden');
                if (priceMapped) priceMapped.classList.remove('visibility-hidden');
                this.toggleAddButton(!this.currentVariant.available, this.currentVariant.preorder, window.variantStrings.soldOut);
            });
    }
  
    toggleAddButton(disable = true, preorder = false, text, modifyClass = true) {

        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-template--${this.dataset.section}__main-sticky-atc-cta`);
        productForms.forEach((productForm) => {
            if (!productForm) return;
            const addButton = productForm.querySelector('[name="add"]');
            const addButtonText = productForm.querySelector('[name="add"] > span');

            if (!addButton) return;

            if (disable) {
                addButton.setAttribute('disabled', 'disabled');
                if (text) addButtonText.textContent = text;
            } else if (preorder) {
                addButton.removeAttribute('disabled');
                if (text) addButtonText.textContent = window.variantStrings.preOrder;
            }
            else {
                addButton.removeAttribute('disabled');
                addButtonText.textContent = window.variantStrings.addToCart;
            }
      
            if (!modifyClass) return;
        });
    }
  
    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
    }
  
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

if(!customElements.get('variant-selects')) {
    customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }
  
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

if(!customElements.get('variant-radios')) {  
    customElements.define('variant-radios', VariantRadios);
}

export {
    VariantSelects,
    VariantRadios
}
